(() => {
  const wizard = document.getElementById('pp-branding-wizard');
  if (!wizard || wizard.dataset.initialised === 'true') return;

  wizard.dataset.initialised = 'true';

  const status = wizard.querySelector('[data-pp-status]');
  const brandingButtons = Array.from(
    wizard.querySelectorAll('[data-pp-branding]')
  );
  const positionButtons = Array.from(
    wizard.querySelectorAll('[data-pp-position]')
  );
  const positionStep = wizard.querySelector('[data-pp-position-step]');
  const selectedMessage = wizard.querySelector(
    '[data-pp-selected-message]'
  );

  function getBrandingRadios() {
    return Array.from(
      document.querySelectorAll(
        '.product-customizer-option[data-option-name="branding"] input[type="radio"]'
      )
    );
  }

  function getPositionInputs() {
    return Array.from(
      document.querySelectorAll(
        '.product-customizer-option[data-option-name="branding-positions"] input[type="checkbox"]'
      )
    );
  }

  function findByValue(inputs, value) {
    return inputs.find(
      (input) => input.value.trim() === value.trim()
    );
  }

  function updateBrandingVisual(value) {
    brandingButtons.forEach((button) => {
      button.classList.toggle(
        'is-selected',
        button.dataset.ppBranding === value
      );
    });

    const branded = value === 'Yes – Add my logo';
    positionStep.hidden = !branded;
  }

  function updatePositionVisuals() {
    const positionInputs = getPositionInputs();
    let selectedCount = 0;

    positionButtons.forEach((button) => {
      const matchingInput = findByValue(
        positionInputs,
        button.dataset.ppPosition
      );

      const selected = Boolean(
        matchingInput && matchingInput.checked
      );

      button.classList.toggle('is-selected', selected);

      if (selected) selectedCount += 1;
    });

    if (selectedCount === 0) {
      selectedMessage.textContent = 'No positions selected';
    } else if (selectedCount === 1) {
      selectedMessage.textContent = '1 position selected';
    } else {
      selectedMessage.textContent =
        selectedCount + ' positions selected';
    }
  }

  function enforceBrandingSelection(value) {
    let radios = getBrandingRadios();
    let matchingRadio = findByValue(radios, value);

    if (!matchingRadio) return;

    matchingRadio.click();

    window.setTimeout(() => {
      radios = getBrandingRadios();

      radios.forEach((radio) => {
        const selected =
          radio.value.trim() === value.trim();

        radio.checked = selected;

        if (selected) {
          radio.setAttribute('checked', 'checked');
        } else {
          radio.removeAttribute('checked');
        }
      });

      matchingRadio = findByValue(radios, value);

      if (matchingRadio) {
        matchingRadio.dispatchEvent(
          new Event('input', { bubbles: true })
        );

        matchingRadio.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }

      updateBrandingVisual(value);

      if (value === 'No – Order unbranded') {
        clearAllPositions();
      }
    }, 100);
  }

  function clearAllPositions() {
    const values = [
      'Left Chest',
      'Right Chest',
      'Centre Front',
      'Large Rear'
    ];

    values.forEach((value) => {
      const currentInputs = getPositionInputs();
      const input = findByValue(currentInputs, value);

      if (input && input.checked) {
        input.click();
      }
    });

    window.setTimeout(updatePositionVisuals, 120);
  }

  function togglePosition(value) {
    let inputs = getPositionInputs();
    let matchingInput = findByValue(inputs, value);

    if (!matchingInput) return;

    const shouldSelect = !matchingInput.checked;

    matchingInput.click();

    window.setTimeout(() => {
      inputs = getPositionInputs();
      matchingInput = findByValue(inputs, value);

      if (matchingInput && matchingInput.checked !== shouldSelect) {
        matchingInput.checked = shouldSelect;

        matchingInput.dispatchEvent(
          new Event('input', { bubbles: true })
        );

        matchingInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }

      updatePositionVisuals();
    }, 100);
  }

  brandingButtons.forEach((button) => {
    button.addEventListener('click', () => {
      enforceBrandingSelection(button.dataset.ppBranding);
    });
  });

  positionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      togglePosition(button.dataset.ppPosition);
    });
  });

  document.addEventListener('change', (event) => {
    if (
      event.target.closest(
        '.product-customizer-option[data-option-name="branding"]'
      )
    ) {
      const selected = getBrandingRadios().find(
        (radio) => radio.checked
      );

      if (selected) {
        updateBrandingVisual(selected.value);
      }
    }

    if (
      event.target.closest(
        '.product-customizer-option[data-option-name="branding-positions"]'
      )
    ) {
      window.setTimeout(updatePositionVisuals, 50);
    }
  });

  let attempts = 0;

  const timer = window.setInterval(() => {
    attempts += 1;

    const radios = getBrandingRadios();
    const positions = getPositionInputs();

    if (radios.length && positions.length) {
      window.clearInterval(timer);

      status.textContent = 'Ready to customise';
      status.classList.add('is-connected');

      const selectedBranding = radios.find(
        (radio) => radio.checked
      );

      if (selectedBranding) {
        updateBrandingVisual(selectedBranding.value);
      }

      updatePositionVisuals();
    }

    if (attempts >= 40) {
      window.clearInterval(timer);
      status.textContent = 'Please refresh';
      status.classList.add('is-error');
    }
  }, 250);
})();

(() => {
  const wizard = document.getElementById('pp-branding-wizard');

  if (!wizard || wizard.dataset.methodsInitialised === 'true') return;

  wizard.dataset.methodsInitialised = 'true';

  const methodMarkup = `
    <section
      class="pp-step pp-method-step"
      data-pp-method-step
      hidden
    >
      <div class="pp-divider"></div>

      <div class="pp-step-heading">
        <span class="pp-step-number">3</span>

        <div>
          <h4>How would you like it branded?</h4>
          <p>
            Choose embroidery or full-colour printing for each position.
          </p>
        </div>
      </div>

      <div class="pp-method-list">

        <div
          class="pp-method-row"
          data-pp-method-row="Left Chest"
          hidden
        >
          <div class="pp-method-location">
            <span class="pp-method-location-icon">LC</span>
            <strong>Left Chest</strong>
          </div>

          <div class="pp-method-options">
            <button
              type="button"
              class="pp-method-choice"
              data-pp-method-group="left-chest-method"
              data-pp-method-value="Embroidery"
            >
              <span class="pp-method-icon">✦</span>

              <span class="pp-method-copy">
                <strong>Embroidery</strong>
                <small>+£4.50 per garment</small>
              </span>

              <span class="pp-method-tick">✓</span>
            </button>

            <button
              type="button"
              class="pp-method-choice"
              data-pp-method-group="left-chest-method"
              data-pp-method-value="Full-colour print"
            >
              <span class="pp-method-icon">◉</span>

              <span class="pp-method-copy">
                <strong>Full-colour print</strong>
                <small>+£3.00 per garment</small>
              </span>

              <span class="pp-method-tick">✓</span>
            </button>
          </div>
        </div>

        <div
          class="pp-method-row"
          data-pp-method-row="Right Chest"
          hidden
        >
          <div class="pp-method-location">
            <span class="pp-method-location-icon">RC</span>
            <strong>Right Chest</strong>
          </div>

          <div class="pp-method-options">
            <button
              type="button"
              class="pp-method-choice"
              data-pp-method-group="right-chest-method"
              data-pp-method-value="Embroidery"
            >
              <span class="pp-method-icon">✦</span>

              <span class="pp-method-copy">
                <strong>Embroidery</strong>
                <small>+£4.50 per garment</small>
              </span>

              <span class="pp-method-tick">✓</span>
            </button>

            <button
              type="button"
              class="pp-method-choice"
              data-pp-method-group="right-chest-method"
              data-pp-method-value="Full-colour print"
            >
              <span class="pp-method-icon">◉</span>

              <span class="pp-method-copy">
                <strong>Full-colour print</strong>
                <small>+£3.00 per garment</small>
              </span>

              <span class="pp-method-tick">✓</span>
            </button>
          </div>
        </div>

        <div
          class="pp-method-row"
          data-pp-method-row="Centre Front"
          hidden
        >
          <div class="pp-method-location">
            <span class="pp-method-location-icon">CF</span>
            <strong>Centre Front</strong>
          </div>

          <div class="pp-method-options">
            <button
              type="button"
              class="pp-method-choice"
              data-pp-method-group="centre-front-method"
              data-pp-method-value="Embroidery"
            >
              <span class="pp-method-icon">✦</span>

              <span class="pp-method-copy">
                <strong>Embroidery</strong>
                <small>+£6.50 per garment</small>
              </span>

              <span class="pp-method-tick">✓</span>
            </button>

            <button
              type="button"
              class="pp-method-choice"
              data-pp-method-group="centre-front-method"
              data-pp-method-value="Full-colour print"
            >
              <span class="pp-method-icon">◉</span>

              <span class="pp-method-copy">
                <strong>Full-colour print</strong>
                <small>+£5.00 per garment</small>
              </span>

              <span class="pp-method-tick">✓</span>
            </button>
          </div>
        </div>

        <div
          class="pp-method-row"
          data-pp-method-row="Large Rear"
          hidden
        >
          <div class="pp-method-location">
            <span class="pp-method-location-icon">LR</span>
            <strong>Large Rear</strong>
          </div>

          <div class="pp-method-options">
            <button
              type="button"
              class="pp-method-choice"
              data-pp-method-group="large-rear-method"
              data-pp-method-value="Embroidery"
            >
              <span class="pp-method-icon">✦</span>

              <span class="pp-method-copy">
                <strong>Embroidery</strong>
                <small>+£6.50 per garment</small>
              </span>

              <span class="pp-method-tick">✓</span>
            </button>

            <button
              type="button"
              class="pp-method-choice"
              data-pp-method-group="large-rear-method"
              data-pp-method-value="Full-colour print"
            >
              <span class="pp-method-icon">◉</span>

              <span class="pp-method-copy">
                <strong>Full-colour print</strong>
                <small>+£5.00 per garment</small>
              </span>

              <span class="pp-method-tick">✓</span>
            </button>
          </div>
        </div>

      </div>

      <div class="pp-help-note">
        <span>ⓘ</span>
        Embroidery setup is charged separately when a new embroidery
        file is required.
      </div>
    </section>
  `;

  wizard.insertAdjacentHTML('beforeend', methodMarkup);

  const methodStep = wizard.querySelector('[data-pp-method-step]');
  const methodRows = Array.from(
    wizard.querySelectorAll('[data-pp-method-row]')
  );
  const methodButtons = Array.from(
    wizard.querySelectorAll('[data-pp-method-group]')
  );

  const positionConfig = {
    'Left Chest': 'left-chest-method',
    'Right Chest': 'right-chest-method',
    'Centre Front': 'centre-front-method',
    'Large Rear': 'large-rear-method'
  };

  function getPositionInputs() {
    return Array.from(
      document.querySelectorAll(
        '.product-customizer-option[data-option-name="branding-positions"] input[type="checkbox"]'
      )
    );
  }

  function getMethodRadios(group) {
    return Array.from(
      document.querySelectorAll(
        '.product-customizer-option[data-option-name="' +
        group +
        '"] input[type="radio"]'
      )
    );
  }

  function findByValue(inputs, value) {
    return inputs.find(
      (input) => input.value.trim() === value.trim()
    );
  }

  function isPositionSelected(position) {
    const input = findByValue(getPositionInputs(), position);
    return Boolean(input && input.checked);
  }

  function clearMethod(group) {
    const radios = getMethodRadios(group);

    radios.forEach((radio) => {
      if (radio.checked) {
        radio.checked = false;
        radio.removeAttribute('checked');

        radio.dispatchEvent(
          new Event('input', { bubbles: true })
        );

        radio.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    });
  }

  function updateMethodButtons(group) {
    const radios = getMethodRadios(group);
    const selected = radios.find((radio) => radio.checked);

    methodButtons
      .filter((button) => button.dataset.ppMethodGroup === group)
      .forEach((button) => {
        button.classList.toggle(
          'is-selected',
          Boolean(
            selected &&
            selected.value.trim() ===
              button.dataset.ppMethodValue.trim()
          )
        );
      });
  }

  function refreshMethodStep() {
    let selectedCount = 0;

    methodRows.forEach((row) => {
      const position = row.dataset.ppMethodRow;
      const group = positionConfig[position];
      const selected = isPositionSelected(position);

      row.hidden = !selected;

      if (selected) {
        selectedCount += 1;
        updateMethodButtons(group);
      } else {
        clearMethod(group);
        updateMethodButtons(group);
      }
    });

    methodStep.hidden = selectedCount === 0;
  }

  function selectMethod(group, value) {
    let radios = getMethodRadios(group);
    let matchingRadio = findByValue(radios, value);

    if (!matchingRadio) return;

    matchingRadio.click();

    window.setTimeout(() => {
      radios = getMethodRadios(group);

      radios.forEach((radio) => {
        const selected =
          radio.value.trim() === value.trim();

        radio.checked = selected;

        if (selected) {
          radio.setAttribute('checked', 'checked');
        } else {
          radio.removeAttribute('checked');
        }
      });

      matchingRadio = findByValue(radios, value);

      if (matchingRadio) {
        matchingRadio.dispatchEvent(
          new Event('input', { bubbles: true })
        );

        matchingRadio.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }

      updateMethodButtons(group);
    }, 100);
  }

  methodButtons.forEach((button) => {
    button.addEventListener('click', () => {
      selectMethod(
        button.dataset.ppMethodGroup,
        button.dataset.ppMethodValue
      );
    });
  });

  wizard.addEventListener('click', (event) => {
    if (
      event.target.closest('[data-pp-position]') ||
      event.target.closest('[data-pp-branding]')
    ) {
      window.setTimeout(refreshMethodStep, 180);
    }
  });

  document.addEventListener('change', (event) => {
    const option = event.target.closest(
      '.product-customizer-option'
    );

    if (!option) return;

    const optionName = option.dataset.optionName || '';

    if (
      optionName === 'branding-positions' ||
      optionName === 'branding'
    ) {
      window.setTimeout(refreshMethodStep, 120);
    }

    if (
      [
        'left-chest-method',
        'right-chest-method',
        'centre-front-method',
        'large-rear-method'
      ].includes(optionName)
    ) {
      window.setTimeout(
        () => updateMethodButtons(optionName),
        80
      );
    }
  });

  let attempts = 0;

  const timer = window.setInterval(() => {
    attempts += 1;

    const allGroupsAvailable = Object.values(positionConfig).every(
      (group) => getMethodRadios(group).length > 0
    );

    if (allGroupsAvailable) {
      window.clearInterval(timer);
      refreshMethodStep();
    }

    if (attempts >= 40) {
      window.clearInterval(timer);
    }
  }, 250);
})();

/* STEP 4 — ARTWORK */

(() => {
  const wizard = document.getElementById('pp-branding-wizard');

  if (!wizard || wizard.dataset.artworkInitialised === 'true') return;

  wizard.dataset.artworkInitialised = 'true';

  const positionConfig = {
    'Left Chest': 'left-chest-method',
    'Right Chest': 'right-chest-method',
    'Centre Front': 'centre-front-method',
    'Large Rear': 'large-rear-method'
  };

  const uploadNameConfig = {
    'Left Chest': 'Left Chest',
    'Right Chest': 'Right Chest',
    'Centre Front': 'Centre Front',
    'Large Rear': 'Large Rear'
  };

  const artworkMarkup = `
    <section
      class="pp-step pp-artwork-step"
      data-pp-artwork-step
      hidden
    >
      <div class="pp-divider"></div>

      <div class="pp-step-heading">
        <span class="pp-step-number">4</span>

        <div>
          <h4>Provide your artwork</h4>
          <p>
            Tell us which logo or design should be used for your branding.
          </p>
        </div>
      </div>

      <div class="pp-artwork-intro" data-pp-artwork-intro>
        Your branding positions and decoration methods are ready.
      </div>

      <div
        class="pp-logo-assignment"
        data-pp-logo-assignment-section
      >
        <p class="pp-subheading">
          Are you using the same logo for every position?
        </p>

        <div class="pp-assignment-grid">
          <button
            type="button"
            class="pp-assignment-choice"
            data-pp-assignment="Same logo for all positions"
          >
            <strong>Same logo</strong>
            <small>
              Use one logo or design across every selected position
            </small>
            <span class="pp-assignment-tick">✓</span>
          </button>

          <button
            type="button"
            class="pp-assignment-choice"
            data-pp-assignment="Different logo for each position"
          >
            <strong>Different logos</strong>
            <small>
              Upload a separate design for each selected position
            </small>
            <span class="pp-assignment-tick">✓</span>
          </button>
        </div>
      </div>

      <div
        class="pp-artwork-source"
        data-pp-artwork-source-section
        hidden
      >
        <p class="pp-subheading">
          How would you like to provide your artwork?
        </p>

        <div class="pp-artwork-source-grid">
          <button
            type="button"
            class="pp-artwork-choice"
            data-pp-artwork-source="Upload a new logo"
          >
            <span class="pp-artwork-icon">↑</span>
            <strong>Upload a new logo</strong>
            <small>
              Send us your logo or finished artwork
            </small>
            <span class="pp-artwork-tick">✓</span>
          </button>

          <button
            type="button"
            class="pp-artwork-choice"
            data-pp-artwork-source="ProPrint already has my logo"
          >
            <span class="pp-artwork-icon">✓</span>
            <strong>Use my saved logo</strong>
            <small>
              You have previously ordered from ProPrint
            </small>
            <span class="pp-artwork-tick">✓</span>
          </button>

          <button
            type="button"
            class="pp-artwork-choice"
            data-pp-artwork-source="Create branding from text"
          >
            <span class="pp-artwork-icon">T</span>
            <strong>Create from text</strong>
            <small>
              Enter wording for simple text-based branding
            </small>
            <span class="pp-artwork-tick">✓</span>
          </button>
        </div>

        <div class="pp-artwork-panels">

          <div
            class="pp-artwork-panel"
            data-pp-artwork-panel="Upload a new logo"
            hidden
          >
            <div class="pp-panel-heading">
              <strong>Upload your artwork</strong>
              <small>
                For the best result, upload the highest-quality file
                available. PDF, SVG, EPS, AI, PNG and JPG files are accepted.
              </small>
            </div>

            <div class="pp-upload-list" data-pp-upload-list></div>
          </div>

          <div
            class="pp-artwork-panel"
            data-pp-artwork-panel="ProPrint already has my logo"
            hidden
          >
            <div class="pp-panel-heading">
              <strong>Help us find your saved artwork</strong>
              <small>
                Enter your business name or a previous ProPrint order number.
              </small>
            </div>

            <label
              class="pp-field-label"
              for="pp-existing-logo-details"
            >
              Business name or order number
            </label>

            <input
              id="pp-existing-logo-details"
              class="pp-text-input"
              type="text"
              maxlength="100"
              placeholder="For example: ProPrint or order #1234"
              data-pp-existing-logo
            >

            <span
              class="pp-character-count"
              data-pp-existing-count
            >
              0 / 100
            </span>
          </div>

          <div
            class="pp-artwork-panel"
            data-pp-artwork-panel="Create branding from text"
            hidden
          >
            <div class="pp-panel-heading">
              <strong>Enter your branding text</strong>
              <small>
                Enter the wording exactly as you would like it to appear.
                We will prepare a proof before production.
              </small>
            </div>

            <label
              class="pp-field-label"
              for="pp-branding-text"
            >
              Branding wording
            </label>

            <textarea
              id="pp-branding-text"
              class="pp-textarea"
              maxlength="200"
              placeholder="Enter your business name, wording and any layout instructions..."
              data-pp-branding-text
            ></textarea>

            <span
              class="pp-character-count"
              data-pp-branding-count
            >
              0 / 200
            </span>
          </div>

        </div>

        <div class="pp-proof-note">
          <span>✓</span>
          We’ll check your artwork and send a digital proof for approval
          before your garments enter production.
        </div>
      </div>
    </section>
  `;

  wizard.insertAdjacentHTML('beforeend', artworkMarkup);

  const artworkStep = wizard.querySelector(
    '[data-pp-artwork-step]'
  );

  const artworkIntro = wizard.querySelector(
    '[data-pp-artwork-intro]'
  );

  const assignmentSection = wizard.querySelector(
    '[data-pp-logo-assignment-section]'
  );

  const sourceSection = wizard.querySelector(
    '[data-pp-artwork-source-section]'
  );

  const assignmentButtons = Array.from(
    wizard.querySelectorAll('[data-pp-assignment]')
  );

  const sourceButtons = Array.from(
    wizard.querySelectorAll('[data-pp-artwork-source]')
  );

  const artworkPanels = Array.from(
    wizard.querySelectorAll('[data-pp-artwork-panel]')
  );

  const uploadList = wizard.querySelector(
    '[data-pp-upload-list]'
  );

  const existingLogoField = wizard.querySelector(
    '[data-pp-existing-logo]'
  );

  const existingCount = wizard.querySelector(
    '[data-pp-existing-count]'
  );

  const brandingTextField = wizard.querySelector(
    '[data-pp-branding-text]'
  );

  const brandingCount = wizard.querySelector(
    '[data-pp-branding-count]'
  );

  function getOptionInputs(optionName, type) {
    return Array.from(
      document.querySelectorAll(
        '.product-customizer-option[data-option-name="' +
        optionName +
        '"] input[type="' +
        type +
        '"]'
      )
    );
  }

  function getOptionTextField(optionName) {
    return document.querySelector(
      '.product-customizer-option[data-option-name="' +
      optionName +
      '"] input, ' +
      '.product-customizer-option[data-option-name="' +
      optionName +
      '"] textarea'
    );
  }

  function getPositionInputs() {
    return getOptionInputs('branding-positions', 'checkbox');
  }

  function getSelectedPositions() {
    return getPositionInputs()
      .filter((input) => input.checked)
      .map((input) => input.value.trim());
  }

  function getSelectedRadioValue(optionName) {
    const selected = getOptionInputs(optionName, 'radio')
      .find((radio) => radio.checked);

    return selected ? selected.value.trim() : '';
  }

  function findByValue(inputs, value) {
    return inputs.find(
      (input) => input.value.trim() === value.trim()
    );
  }

  function allMethodsSelected(positions) {
    if (!positions.length) return false;

    return positions.every((position) => {
      const methodGroup = positionConfig[position];

      return Boolean(
        getOptionInputs(methodGroup, 'radio')
          .find((radio) => radio.checked)
      );
    });
  }

  function enforceRadio(optionName, value, callback) {
    let radios = getOptionInputs(optionName, 'radio');
    let matchingRadio = findByValue(radios, value);

    if (!matchingRadio) return;

    matchingRadio.click();

    window.setTimeout(() => {
      radios = getOptionInputs(optionName, 'radio');

      radios.forEach((radio) => {
        const selected = radio.value.trim() === value.trim();

        radio.checked = selected;

        if (selected) {
          radio.setAttribute('checked', 'checked');
        } else {
          radio.removeAttribute('checked');
        }
      });

      matchingRadio = findByValue(radios, value);

      if (matchingRadio) {
        matchingRadio.dispatchEvent(
          new Event('input', { bubbles: true })
        );

        matchingRadio.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }

      if (typeof callback === 'function') {
        callback();
      }
    }, 100);
  }

  function updateAssignmentButtons() {
    const selected = getSelectedRadioValue('logo-assignment');

    assignmentButtons.forEach((button) => {
      button.classList.toggle(
        'is-selected',
        button.dataset.ppAssignment === selected
      );
    });

    return selected;
  }

  function updateSourceButtons() {
    const selected = getSelectedRadioValue('artwork-source');

    sourceButtons.forEach((button) => {
      button.classList.toggle(
        'is-selected',
        button.dataset.ppArtworkSource === selected
      );
    });

    artworkPanels.forEach((panel) => {
      panel.hidden =
        panel.dataset.ppArtworkPanel !== selected;
    });

    return selected;
  }

  function getNativeFileInput(propertyName) {
    return Array.from(
      document.querySelectorAll(
        '.product-customizer-option[data-option-name="logo-files"] input[type="file"]'
      )
    ).find(
      (input) =>
        input.getAttribute('name') ===
        'properties[' + propertyName + ']'
    );
  }

  function copyFilesToNative(customInput, propertyName) {
    const nativeInput = getNativeFileInput(propertyName);

    if (!nativeInput || !customInput.files.length) return;

    try {
      const transfer = new DataTransfer();

      Array.from(customInput.files).forEach((file) => {
        transfer.items.add(file);
      });

      nativeInput.files = transfer.files;

      nativeInput.dispatchEvent(
        new Event('input', { bubbles: true })
      );

      nativeInput.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    } catch (error) {
      console.warn(
        'ProPrint artwork upload could not be copied:',
        error
      );
    }
  }

  function clearNativeUploads() {
    const nativeInputs = document.querySelectorAll(
      '.product-customizer-option[data-option-name="logo-files"] input[type="file"]'
    );

    nativeInputs.forEach((input) => {
      input.value = '';

      input.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });

    uploadList.innerHTML = '';
    delete uploadList.dataset.signature;
  }

  function createUploadField(label, propertyName) {
    const field = document.createElement('div');
    field.className = 'pp-upload-field';

    const fieldLabel = document.createElement('label');
    fieldLabel.textContent = label;

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.ai,.eps,.pdf,.svg,.png,.jpg,.jpeg';
    input.dataset.ppUploadTarget = propertyName;

    const filename = document.createElement('span');
    filename.className = 'pp-upload-filename';
    filename.textContent = 'No file selected';

    input.addEventListener('change', () => {
      filename.textContent = input.files.length
        ? input.files[0].name
        : 'No file selected';

      copyFilesToNative(input, propertyName);
    });

    field.appendChild(fieldLabel);
    field.appendChild(input);
    field.appendChild(filename);

    return field;
  }

  function renderUploadFields(positions, assignment) {
    const signature =
      assignment + '|' + positions.join('|');

    if (uploadList.dataset.signature === signature) return;

    uploadList.innerHTML = '';
    uploadList.dataset.signature = signature;

    if (assignment === 'Same logo for all positions') {
      uploadList.appendChild(
        createUploadField(
          'Main logo — used for all selected positions',
          'Main Logo'
        )
      );

      return;
    }

    positions.forEach((position) => {
      uploadList.appendChild(
        createUploadField(
          position + ' artwork',
          uploadNameConfig[position]
        )
      );
    });
  }

  function updateIntro(positions) {
    if (positions.length === 1) {
      artworkIntro.innerHTML =
        '<strong>' +
        positions[0] +
        ' selected.</strong> Upload or provide the artwork for this position.';
      return;
    }

    artworkIntro.innerHTML =
      '<strong>' +
      positions.length +
      ' branding positions selected.</strong> Choose whether they use the same logo or different artwork.';
  }

  function syncTextToPC(optionName, value) {
    const nativeField = getOptionTextField(optionName);

    if (!nativeField) return;

    nativeField.value = value;

    nativeField.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    nativeField.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }

  function clearTextField(optionName) {
    const nativeField = getOptionTextField(optionName);

    if (!nativeField) return;

    nativeField.value = '';

    nativeField.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    nativeField.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }

  function updateCharacterCounts() {
    existingCount.textContent =
      existingLogoField.value.length + ' / 100';

    brandingCount.textContent =
      brandingTextField.value.length + ' / 200';
  }

  function refreshArtworkStep() {
    const positions = getSelectedPositions();

    if (!allMethodsSelected(positions)) {
      artworkStep.hidden = true;
      return;
    }

    artworkStep.hidden = false;
    updateIntro(positions);

    if (positions.length === 1) {
      assignmentSection.hidden = true;

      const currentAssignment =
        getSelectedRadioValue('logo-assignment');

      if (
        currentAssignment !== 'Same logo for all positions'
      ) {
        enforceRadio(
          'logo-assignment',
          'Same logo for all positions',
          refreshArtworkStep
        );

        return;
      }
    } else {
      assignmentSection.hidden = false;
    }

    const assignment = updateAssignmentButtons();

    sourceSection.hidden = !assignment;

    if (!assignment) {
      artworkPanels.forEach((panel) => {
        panel.hidden = true;
      });

      return;
    }

    const source = updateSourceButtons();

    if (source === 'Upload a new logo') {
      renderUploadFields(positions, assignment);
    }

    const nativeExisting = getOptionTextField(
      'existing-logo-details'
    );

    const nativeBrandingText = getOptionTextField(
      'branding-text'
    );

    if (
      nativeExisting &&
      !existingLogoField.value &&
      nativeExisting.value
    ) {
      existingLogoField.value = nativeExisting.value;
    }

    if (
      nativeBrandingText &&
      !brandingTextField.value &&
      nativeBrandingText.value
    ) {
      brandingTextField.value = nativeBrandingText.value;
    }

    updateCharacterCounts();
  }

  assignmentButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const newAssignment = button.dataset.ppAssignment;
      const oldAssignment =
        getSelectedRadioValue('logo-assignment');

      if (newAssignment !== oldAssignment) {
        clearNativeUploads();
      }

      enforceRadio(
        'logo-assignment',
        newAssignment,
        refreshArtworkStep
      );
    });
  });

  sourceButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const source = button.dataset.ppArtworkSource;
      const oldSource = getSelectedRadioValue(
        'artwork-source'
      );

      if (source !== oldSource) {
        if (source !== 'Upload a new logo') {
          clearNativeUploads();
        }

        if (
          source !== 'ProPrint already has my logo'
        ) {
          existingLogoField.value = '';
          clearTextField('existing-logo-details');
        }

        if (source !== 'Create branding from text') {
          brandingTextField.value = '';
          clearTextField('branding-text');
        }

        updateCharacterCounts();
      }

      enforceRadio(
        'artwork-source',
        source,
        refreshArtworkStep
      );
    });
  });

  existingLogoField.addEventListener('input', () => {
    syncTextToPC(
      'existing-logo-details',
      existingLogoField.value
    );

    updateCharacterCounts();
  });

  brandingTextField.addEventListener('input', () => {
    syncTextToPC(
      'branding-text',
      brandingTextField.value
    );

    updateCharacterCounts();
  });

  wizard.addEventListener('click', (event) => {
    if (
      event.target.closest('[data-pp-position]') ||
      event.target.closest('[data-pp-branding]') ||
      event.target.closest('[data-pp-method-group]')
    ) {
      window.setTimeout(refreshArtworkStep, 220);
    }
  });

  document.addEventListener('change', (event) => {
    const option = event.target.closest(
      '.product-customizer-option'
    );

    if (!option) return;

    const optionName = option.dataset.optionName || '';

    if (
      [
        'branding',
        'branding-positions',
        'left-chest-method',
        'right-chest-method',
        'centre-front-method',
        'large-rear-method',
        'logo-assignment',
        'artwork-source'
      ].includes(optionName)
    ) {
      window.setTimeout(refreshArtworkStep, 130);
    }
  });

  let attempts = 0;

  const timer = window.setInterval(() => {
    attempts += 1;

    const requiredOptionsAvailable =
      getPositionInputs().length > 0 &&
      getOptionInputs('logo-assignment', 'radio').length > 0 &&
      getOptionInputs('artwork-source', 'radio').length > 0 &&
      Boolean(
        getOptionTextField('existing-logo-details')
      ) &&
      Boolean(
        getOptionTextField('branding-text')
      );

    if (requiredOptionsAvailable) {
      window.clearInterval(timer);
      refreshArtworkStep();
    }

    if (attempts >= 40) {
      window.clearInterval(timer);
    }
  }, 250);
})();

/* STEP 5 — EMBROIDERY DIGITISATION */

(() => {
  const wizard = document.getElementById('pp-branding-wizard');

  if (!wizard || wizard.dataset.digitisingInitialised === 'true') {
    return;
  }

  wizard.dataset.digitisingInitialised = 'true';

  const CHEST_VARIANT_ID = 58912510017880;
  const LARGE_VARIANT_ID = 58912510050648;

  const positionConfig = {
    'Left Chest': {
      method: 'left-chest-method',
      size: 'chest',
      marker: 'Left chest logo setup'
    },
    'Right Chest': {
      method: 'right-chest-method',
      size: 'chest',
      marker: 'Right chest logo setup'
    },
    'Centre Front': {
      method: 'centre-front-method',
      size: 'large',
      marker: 'Centre front logo setup'
    },
    'Large Rear': {
      method: 'large-rear-method',
      size: 'large',
      marker: 'Large rear logo setup'
    }
  };

  const digitisingMarkup = `
    <section
      class="pp-step pp-digitising-step"
      data-pp-digitising-step
      hidden
    >
      <div class="pp-divider"></div>

      <div class="pp-step-heading">
        <span class="pp-step-number">5</span>

        <div>
          <h4>Embroidery setup</h4>
          <p>
            Tell us whether your logo is already prepared for embroidery.
          </p>
        </div>
      </div>

      <div class="pp-digitising-info">
        <strong>Why is digitisation needed?</strong><br>
        Embroidery machines require a specialist stitch file rather than
        a standard image. This is a one-off setup charge and your file
        will be kept for future ProPrint orders.
      </div>

      <div class="pp-setup-list" data-pp-setup-list></div>

      <div class="pp-setup-summary" data-pp-setup-summary>
        <div class="pp-setup-summary-copy">
          <strong data-pp-setup-summary-title>
            Complete the options above
          </strong>
          <small data-pp-setup-summary-text>
            Select an answer for each required embroidery file.
          </small>
        </div>

        <div class="pp-setup-total" data-pp-setup-total>
          —
        </div>
      </div>
    </section>
  `;

  wizard.insertAdjacentHTML('beforeend', digitisingMarkup);

  const digitisingStep = wizard.querySelector(
    '[data-pp-digitising-step]'
  );

  const setupList = wizard.querySelector(
    '[data-pp-setup-list]'
  );

  const summaryTitle = wizard.querySelector(
    '[data-pp-setup-summary-title]'
  );

  const summaryText = wizard.querySelector(
    '[data-pp-setup-summary-text]'
  );

  const summaryTotal = wizard.querySelector(
    '[data-pp-setup-total]'
  );

  const setupState = {};
  let currentGroups = [];

  function getOptionInputs(optionName, type) {
    return Array.from(
      document.querySelectorAll(
        '.product-customizer-option[data-option-name="' +
        optionName +
        '"] input[type="' +
        type +
        '"]'
      )
    );
  }

  function getSelectedRadioValue(optionName) {
    const selected = getOptionInputs(optionName, 'radio')
      .find((radio) => radio.checked);

    return selected ? selected.value.trim() : '';
  }

  function getSelectedPositions() {
    return getOptionInputs(
      'branding-positions',
      'checkbox'
    )
      .filter((input) => input.checked)
      .map((input) => input.value.trim());
  }

  function getPositionMethod(position) {
    const config = positionConfig[position];

    if (!config) return '';

    return getSelectedRadioValue(config.method);
  }

  function getEmbroideryPositions() {
    return getSelectedPositions().filter(
      (position) =>
        getPositionMethod(position) === 'Embroidery'
    );
  }

  function makeGroup(key, size, positions) {
    const isChest = size === 'chest';
    const sameLogo =
      getSelectedRadioValue('logo-assignment') ===
      'Same logo for all positions';

    let title;

    if (sameLogo) {
      title = isChest
        ? 'Chest-size embroidery file'
        : 'Large embroidery file';
    } else {
      title = positions[0] + ' embroidery file';
    }

    return {
      key,
      size,
      positions,
      title,
      price: isChest ? 10 : 15,
      variantId: isChest
        ? CHEST_VARIANT_ID
        : LARGE_VARIANT_ID,
      marker: positionConfig[positions[0]].marker
    };
  }

  function buildSetupGroups() {
    const embroideryPositions = getEmbroideryPositions();
    const assignment = getSelectedRadioValue(
      'logo-assignment'
    );

    if (!embroideryPositions.length || !assignment) {
      return [];
    }

    if (assignment === 'Same logo for all positions') {
      const groups = [];

      const chestPositions = embroideryPositions.filter(
        (position) =>
          positionConfig[position].size === 'chest'
      );

      const largePositions = embroideryPositions.filter(
        (position) =>
          positionConfig[position].size === 'large'
      );

      if (chestPositions.length) {
        groups.push(
          makeGroup(
            'same-logo-chest',
            'chest',
            chestPositions
          )
        );
      }

      if (largePositions.length) {
        groups.push(
          makeGroup(
            'same-logo-large',
            'large',
            largePositions
          )
        );
      }

      return groups;
    }

    return embroideryPositions.map((position) => {
      const size = positionConfig[position].size;

      return makeGroup(
        'different-logo-' +
          position.toLowerCase().replace(/\s+/g, '-'),
        size,
        [position]
      );
    });
  }

  function createSetupRow(group) {
    const row = document.createElement('div');
    row.className = 'pp-setup-row';
    row.dataset.ppSetupRow = group.key;

    const positionText = group.positions.join(' + ');
    const icon = group.size === 'chest' ? 'C' : 'L';

    row.innerHTML = `
      <div class="pp-setup-row-heading">
        <div class="pp-setup-row-title">
          <span class="pp-setup-row-icon">${icon}</span>

          <div>
            <strong>${group.title}</strong>
            <small>Used for: ${positionText}</small>
          </div>
        </div>

        <span class="pp-one-off-badge">
          ONE-OFF FEE
        </span>
      </div>

      <div class="pp-setup-options">
        <button
          type="button"
          class="pp-setup-choice"
          data-pp-setup-group="${group.key}"
          data-pp-setup-answer="saved"
        >
          <strong>ProPrint already has this file</strong>
          <small>No additional setup charge</small>
          <span class="pp-setup-tick">✓</span>
        </button>

        <button
          type="button"
          class="pp-setup-choice"
          data-pp-setup-group="${group.key}"
          data-pp-setup-answer="new"
        >
          <strong>Create a new embroidery file</strong>
          <small>+£${group.price.toFixed(2)} one-off</small>
          <span class="pp-setup-tick">✓</span>
        </button>
      </div>
    `;

    return row;
  }

  function updateSetupButtons() {
    const buttons = Array.from(
      setupList.querySelectorAll('[data-pp-setup-group]')
    );

    buttons.forEach((button) => {
      const groupKey = button.dataset.ppSetupGroup;
      const answer = button.dataset.ppSetupAnswer;

      button.classList.toggle(
        'is-selected',
        setupState[groupKey] === answer
      );
    });
  }

  function getDigitisingInputs() {
    return getOptionInputs(
      'digitising-required',
      'checkbox'
    );
  }

  function syncDigitisingMarkers() {
    const requiredMarkers = currentGroups
      .filter(
        (group) => setupState[group.key] === 'new'
      )
      .map((group) => group.marker);

    getDigitisingInputs().forEach((input) => {
      const shouldBeChecked = requiredMarkers.includes(
        input.value.trim()
      );

      if (input.checked !== shouldBeChecked) {
        input.click();
      }
    });

    window.setTimeout(() => {
      getDigitisingInputs().forEach((input) => {
        const shouldBeChecked = requiredMarkers.includes(
          input.value.trim()
        );

        if (input.checked !== shouldBeChecked) {
          input.checked = shouldBeChecked;

          input.dispatchEvent(
            new Event('input', { bubbles: true })
          );

          input.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        }
      });
    }, 100);
  }

  function updateSetupSummary() {
    const incompleteGroups = currentGroups.filter(
      (group) => !setupState[group.key]
    );

    if (incompleteGroups.length) {
      summaryTitle.textContent =
        'Complete the options above';

      summaryText.textContent =
        'Select an answer for each required embroidery file.';

      summaryTotal.textContent = '—';
      updateWizardData();
      return;
    }

    const newSetups = currentGroups.filter(
      (group) => setupState[group.key] === 'new'
    );

    const total = newSetups.reduce(
      (amount, group) => amount + group.price,
      0
    );

    if (!newSetups.length) {
      summaryTitle.textContent =
        'No new digitisation required';

      summaryText.textContent =
        'We’ll use your existing embroidery file at no extra charge.';

      summaryTotal.textContent = '£0.00';
      updateWizardData();
      return;
    }

    summaryTitle.textContent =
      newSetups.length === 1
        ? '1 new embroidery file'
        : newSetups.length + ' new embroidery files';

    summaryText.textContent =
      'This is a one-off setup charge and will not be multiplied by garment quantity.';

    summaryTotal.textContent = '£' + total.toFixed(2);
    updateWizardData();
  }

  function updateWizardData() {
    window.ProPrintBrandingWizard =
      window.ProPrintBrandingWizard || {};

    window.ProPrintBrandingWizard.getDigitisingItems =
      function () {
        return currentGroups
          .filter(
            (group) => setupState[group.key] === 'new'
          )
          .map((group) => ({
            id: group.variantId,
            quantity: 1,
            properties: {
              'Digitisation for':
                group.positions.join(' + '),
              'Artwork arrangement':
                getSelectedRadioValue('logo-assignment')
            }
          }));
      };

    window.ProPrintBrandingWizard.isDigitisingComplete =
      function () {
        return currentGroups.every(
          (group) => Boolean(setupState[group.key])
        );
      };

    window.ProPrintBrandingWizard.getDigitisingTotal =
      function () {
        return currentGroups
          .filter(
            (group) => setupState[group.key] === 'new'
          )
          .reduce(
            (amount, group) => amount + group.price,
            0
          );
      };
  }

  function renderSetupGroups(groups) {
    const signature = groups
      .map(
        (group) =>
          group.key +
          ':' +
          group.positions.join(',')
      )
      .join('|');

    if (setupList.dataset.signature === signature) {
      currentGroups = groups;
      updateSetupButtons();
      updateSetupSummary();
      return;
    }

    setupList.innerHTML = '';
    setupList.dataset.signature = signature;
    currentGroups = groups;

    groups.forEach((group) => {
      setupList.appendChild(createSetupRow(group));
    });

    updateSetupButtons();
    syncDigitisingMarkers();
    updateSetupSummary();
  }

  function clearDigitisingMarkers() {
    currentGroups = [];

    getDigitisingInputs().forEach((input) => {
      if (input.checked) {
        input.click();
      }
    });

    updateWizardData();
  }

  function refreshDigitisingStep() {
    const artworkSource = getSelectedRadioValue(
      'artwork-source'
    );

    const groups = buildSetupGroups();

    if (!artworkSource || !groups.length) {
      digitisingStep.hidden = true;
      setupList.innerHTML = '';
      delete setupList.dataset.signature;
      clearDigitisingMarkers();
      return;
    }

    digitisingStep.hidden = false;
    renderSetupGroups(groups);
  }

  setupList.addEventListener('click', (event) => {
    const button = event.target.closest(
      '[data-pp-setup-group]'
    );

    if (!button) return;

    setupState[button.dataset.ppSetupGroup] =
      button.dataset.ppSetupAnswer;

    updateSetupButtons();
    syncDigitisingMarkers();
    updateSetupSummary();
  });

  wizard.addEventListener('click', (event) => {
    if (
      event.target.closest('[data-pp-branding]') ||
      event.target.closest('[data-pp-position]') ||
      event.target.closest('[data-pp-method-group]') ||
      event.target.closest('[data-pp-assignment]') ||
      event.target.closest('[data-pp-artwork-source]')
    ) {
      window.setTimeout(refreshDigitisingStep, 250);
    }
  });

  document.addEventListener('change', (event) => {
    const option = event.target.closest(
      '.product-customizer-option'
    );

    if (!option) return;

    const optionName = option.dataset.optionName || '';

    if (
      [
        'branding',
        'branding-positions',
        'left-chest-method',
        'right-chest-method',
        'centre-front-method',
        'large-rear-method',
        'logo-assignment',
        'artwork-source'
      ].includes(optionName)
    ) {
      window.setTimeout(
        refreshDigitisingStep,
        150
      );
    }
  });

  let attempts = 0;

  const timer = window.setInterval(() => {
    attempts += 1;

    const ready =
      getOptionInputs(
        'digitising-required',
        'checkbox'
      ).length > 0 &&
      getOptionInputs(
        'artwork-source',
        'radio'
      ).length > 0;

    if (ready) {
      window.clearInterval(timer);
      refreshDigitisingStep();
    }

    if (attempts >= 40) {
      window.clearInterval(timer);
    }
  }, 250);
})();

/* FINAL STEP — ORDER DETAILS & SUMMARY */

(() => {
  const wizard = document.getElementById('pp-branding-wizard');

  if (!wizard || wizard.dataset.reviewInitialised === 'true') {
    return;
  }

  wizard.dataset.reviewInitialised = 'true';

  const positionConfig = {
    'Left Chest': 'left-chest-method',
    'Right Chest': 'right-chest-method',
    'Centre Front': 'centre-front-method',
    'Large Rear': 'large-rear-method'
  };

  const reviewMarkup = `
    <section
      class="pp-step pp-review-step"
      data-pp-review-step
      hidden
    >
      <div class="pp-divider"></div>

      <div class="pp-step-heading">
        <span
          class="pp-step-number"
          data-pp-review-number
        >
          6
        </span>

        <div>
          <h4>Order details & summary</h4>
          <p>
            Check your selections and add any final instructions.
          </p>
        </div>
      </div>

      <div class="pp-notes-box">
        <label
          class="pp-field-label"
          for="pp-order-notes"
        >
          Additional order notes
        </label>

        <textarea
          id="pp-order-notes"
          class="pp-textarea"
          maxlength="150"
          placeholder="Add any colour, positioning or order instructions here..."
          data-pp-order-notes
        ></textarea>

        <span
          class="pp-character-count"
          data-pp-notes-count
        >
          0 / 150
        </span>
      </div>

      <div class="pp-review-summary">
        <div class="pp-review-summary-heading">
          Your customisation summary
        </div>

        <div
          class="pp-review-list"
          data-pp-review-list
        ></div>
      </div>

      <div
        class="pp-ready-status is-incomplete"
        data-pp-ready-status
      >
        <span class="pp-ready-icon" data-pp-ready-icon>
          !
        </span>

        <div class="pp-ready-copy">
          <strong data-pp-ready-title>
            Complete your options
          </strong>

          <small data-pp-ready-message>
            Finish the required choices above before adding to basket.
          </small>
        </div>
      </div>
    </section>
  `;

  wizard.insertAdjacentHTML('beforeend', reviewMarkup);

  const reviewStep = wizard.querySelector(
    '[data-pp-review-step]'
  );

  const reviewNumber = wizard.querySelector(
    '[data-pp-review-number]'
  );

  const reviewList = wizard.querySelector(
    '[data-pp-review-list]'
  );

  const notesField = wizard.querySelector(
    '[data-pp-order-notes]'
  );

  const notesCount = wizard.querySelector(
    '[data-pp-notes-count]'
  );

  const readyStatus = wizard.querySelector(
    '[data-pp-ready-status]'
  );

  const readyIcon = wizard.querySelector(
    '[data-pp-ready-icon]'
  );

  const readyTitle = wizard.querySelector(
    '[data-pp-ready-title]'
  );

  const readyMessage = wizard.querySelector(
    '[data-pp-ready-message]'
  );

  function getOptionInputs(optionName, type) {
    return Array.from(
      document.querySelectorAll(
        '.product-customizer-option[data-option-name="' +
        optionName +
        '"] input[type="' +
        type +
        '"]'
      )
    );
  }

  function getSelectedRadioValue(optionName) {
    const selected = getOptionInputs(optionName, 'radio')
      .find((radio) => radio.checked);

    return selected ? selected.value.trim() : '';
  }

  function getSelectedPositions() {
    return getOptionInputs(
      'branding-positions',
      'checkbox'
    )
      .filter((input) => input.checked)
      .map((input) => input.value.trim());
  }

  function getPositionMethod(position) {
    return getSelectedRadioValue(
      positionConfig[position]
    );
  }

  function hasEmbroidery(positions) {
    return positions.some(
      (position) =>
        getPositionMethod(position) === 'Embroidery'
    );
  }

  function allMethodsSelected(positions) {
    return (
      positions.length > 0 &&
      positions.every(
        (position) => Boolean(getPositionMethod(position))
      )
    );
  }

  function getNativeNotesField() {
    return document.querySelector(
      '.product-customizer-option[data-option-name="notes"] textarea'
    );
  }

  function syncNotesToPC() {
    const nativeNotes = getNativeNotesField();

    if (!nativeNotes) return;

    nativeNotes.value = notesField.value;

    nativeNotes.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    nativeNotes.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }

  function updateNotesCount() {
    notesCount.textContent =
      notesField.value.length + ' / 150';
  }

  function addReviewRow(label, value) {
    const row = document.createElement('div');
    row.className = 'pp-review-row';

    const rowLabel = document.createElement('div');
    rowLabel.className = 'pp-review-label';
    rowLabel.textContent = label;

    const rowValue = document.createElement('div');
    rowValue.className = 'pp-review-value';
    rowValue.textContent = value;

    row.appendChild(rowLabel);
    row.appendChild(rowValue);
    reviewList.appendChild(row);
  }

  function getArtworkDescription(source, assignment) {
    if (source === 'Upload a new logo') {
      return assignment === 'Different logo for each position'
        ? 'New artwork uploaded separately for each position'
        : 'One new logo uploaded for all selected positions';
    }

    if (source === 'ProPrint already has my logo') {
      return 'Use artwork already held by ProPrint';
    }

    if (source === 'Create branding from text') {
      return 'Create branding using the supplied wording';
    }

    return 'Not selected';
  }

  function getArtworkValidation(source) {
    if (source === 'Upload a new logo') {
      const uploadInputs = Array.from(
        wizard.querySelectorAll(
          '[data-pp-upload-target]'
        )
      );

      if (!uploadInputs.length) {
        return {
          valid: false,
          message: 'Choose and upload your artwork file.'
        };
      }

      const missingUpload = uploadInputs.some(
        (input) => !input.files || !input.files.length
      );

      return {
        valid: !missingUpload,
        message: missingUpload
          ? 'Upload artwork for every required position.'
          : ''
      };
    }

    if (source === 'ProPrint already has my logo') {
      const field = wizard.querySelector(
        '[data-pp-existing-logo]'
      );

      const valid = Boolean(
        field && field.value.trim()
      );

      return {
        valid,
        message: valid
          ? ''
          : 'Enter your business name or previous order number.'
      };
    }

    if (source === 'Create branding from text') {
      const field = wizard.querySelector(
        '[data-pp-branding-text]'
      );

      const valid = Boolean(
        field && field.value.trim()
      );

      return {
        valid,
        message: valid
          ? ''
          : 'Enter the wording required for your branding.'
      };
    }

    return {
      valid: false,
      message: 'Choose how you would like to provide your artwork.'
    };
  }

  function getDigitisingComplete(embroideryRequired) {
    if (!embroideryRequired) return true;

    return Boolean(
      window.ProPrintBrandingWizard &&
      typeof window.ProPrintBrandingWizard
        .isDigitisingComplete === 'function' &&
      window.ProPrintBrandingWizard
        .isDigitisingComplete()
    );
  }

  function getDigitisingTotal() {
    if (
      window.ProPrintBrandingWizard &&
      typeof window.ProPrintBrandingWizard
        .getDigitisingTotal === 'function'
    ) {
      return window.ProPrintBrandingWizard
        .getDigitisingTotal();
    }

    return 0;
  }

  function setReadyStatus(valid, message) {
    readyStatus.classList.toggle(
      'is-ready',
      valid
    );

    readyStatus.classList.toggle(
      'is-incomplete',
      !valid
    );

    readyIcon.textContent = valid ? '✓' : '!';
    readyTitle.textContent = valid
      ? 'Ready to add to basket'
      : 'Complete your customisation';

    readyMessage.textContent = valid
      ? 'Your selections are complete and ready to be added to your order.'
      : message;
  }

  function updatePublicValidation(valid, message) {
    window.ProPrintBrandingWizard =
      window.ProPrintBrandingWizard || {};

    window.ProPrintBrandingWizard.validate =
      function () {
        return {
          valid,
          message
        };
      };
  }

  function refreshReview() {
    const branding = getSelectedRadioValue('branding');

    if (!branding) {
      reviewStep.hidden = true;
      updatePublicValidation(
        false,
        'Choose whether you would like the garment branded.'
      );
      return;
    }

    reviewList.innerHTML = '';

    if (branding === 'No – Order unbranded') {
      reviewStep.hidden = false;
      reviewNumber.textContent = '2';

      addReviewRow('Garment', 'Order unbranded');
      addReviewRow(
        'Customisation',
        'No embroidery or printing selected'
      );

      setReadyStatus(true, '');
      updatePublicValidation(true, '');
      return;
    }

    const positions = getSelectedPositions();

    if (!positions.length) {
      reviewStep.hidden = true;
      updatePublicValidation(
        false,
        'Select at least one branding position.'
      );
      return;
    }

    if (!allMethodsSelected(positions)) {
      reviewStep.hidden = true;
      updatePublicValidation(
        false,
        'Choose embroidery or printing for each selected position.'
      );
      return;
    }

    const assignment = getSelectedRadioValue(
      'logo-assignment'
    );

    const source = getSelectedRadioValue(
      'artwork-source'
    );

    if (!assignment || !source) {
      reviewStep.hidden = true;
      updatePublicValidation(
        false,
        'Complete the artwork options.'
      );
      return;
    }

    const embroideryRequired = hasEmbroidery(
      positions
    );

    const digitisingComplete =
      getDigitisingComplete(embroideryRequired);

    if (!digitisingComplete) {
      reviewStep.hidden = true;
      updatePublicValidation(
        false,
        'Complete the embroidery setup options.'
      );
      return;
    }

    reviewStep.hidden = false;

    reviewNumber.textContent =
      embroideryRequired ? '6' : '5';

    addReviewRow(
      'Branding',
      'Custom branded garment'
    );

    addReviewRow(
      'Positions',
      positions.join(', ')
    );

    positions.forEach((position) => {
      addReviewRow(
        position,
        getPositionMethod(position)
      );
    });

    if (positions.length > 1) {
      addReviewRow(
        'Logo use',
        assignment === 'Same logo for all positions'
          ? 'Same logo across all selected positions'
          : 'Different logo for each selected position'
      );
    }

    addReviewRow(
      'Artwork',
      getArtworkDescription(source, assignment)
    );

    if (embroideryRequired) {
      const digitisingTotal = getDigitisingTotal();

      addReviewRow(
        'Embroidery setup',
        digitisingTotal > 0
          ? '£' +
              digitisingTotal.toFixed(2) +
              ' one-off'
          : 'Existing files — no setup charge'
      );
    } else {
      addReviewRow(
        'Embroidery setup',
        'Not required'
      );
    }

    const artworkValidation =
      getArtworkValidation(source);

    setReadyStatus(
      artworkValidation.valid,
      artworkValidation.message
    );

    updatePublicValidation(
      artworkValidation.valid,
      artworkValidation.message
    );
  }

  notesField.addEventListener('input', () => {
    syncNotesToPC();
    updateNotesCount();
  });

  wizard.addEventListener('click', (event) => {
    if (
      event.target.closest('[data-pp-branding]') ||
      event.target.closest('[data-pp-position]') ||
      event.target.closest('[data-pp-method-group]') ||
      event.target.closest('[data-pp-assignment]') ||
      event.target.closest('[data-pp-artwork-source]') ||
event.target.closest('[data-pp-setup-group]') ||
event.target.closest('[data-pp-saved-logo-id]')
    ) {
      window.setTimeout(refreshReview, 300);
    }
  });

  wizard.addEventListener('change', (event) => {
    if (event.target.matches('[data-pp-upload-target]')) {
      window.setTimeout(refreshReview, 180);
    }
  });

  wizard.addEventListener('input', (event) => {
    if (
      event.target.matches('[data-pp-existing-logo]') ||
      event.target.matches('[data-pp-branding-text]')
    ) {
      window.setTimeout(refreshReview, 100);
    }
  });

  document.addEventListener('change', (event) => {
    const option = event.target.closest(
      '.product-customizer-option'
    );

    if (!option) return;

    window.setTimeout(refreshReview, 180);
  });

  let attempts = 0;

  const timer = window.setInterval(() => {
    attempts += 1;

    const nativeNotes = getNativeNotesField();

    if (nativeNotes) {
      window.clearInterval(timer);

      if (nativeNotes.value) {
        notesField.value = nativeNotes.value;
      }

      updateNotesCount();
      refreshReview();
    }

    if (attempts >= 40) {
      window.clearInterval(timer);
    }
  }, 250);
})();

/* CART CONNECTION — ONE-OFF DIGITISATION FEES */

(() => {
  if (window.ppCartConnectionInitialised) return;

  window.ppCartConnectionInitialised = true;

  const wizard = document.getElementById(
    'pp-branding-wizard'
  );

  if (!wizard) return;

  function getWizardAPI() {
    return window.ProPrintBrandingWizard || {};
  }

  function showWizardError(message) {
    const readyStatus = wizard.querySelector(
      '[data-pp-ready-status]'
    );

    if (readyStatus) {
      readyStatus.classList.remove('is-ready');
      readyStatus.classList.add('is-incomplete');

      const title = readyStatus.querySelector(
        '[data-pp-ready-title]'
      );

      const text = readyStatus.querySelector(
        '[data-pp-ready-message]'
      );

      const icon = readyStatus.querySelector(
        '[data-pp-ready-icon]'
      );

      if (title) {
        title.textContent = 'Complete your customisation';
      }

      if (text) {
        text.textContent = message;
      }

      if (icon) {
        icon.textContent = '!';
      }
    }

    wizard.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    window.alert(message);
  }

  async function addDigitisingFees(items) {
    const basketItems = items.map((item) => ({
      id: item.id,
      quantity: 1,
      properties: {
        ...item.properties,
        '_ProPrint setup fee': 'Embroidery digitisation'
      }
    }));

    const response = await fetch(
      window.Shopify.routes.root + 'cart/add.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: basketItems
        })
      }
    );

    if (!response.ok) {
      let errorMessage =
        'The embroidery setup fee could not be added. Please try again.';

      try {
        const error = await response.json();

        if (error && error.description) {
          errorMessage = error.description;
        }
      } catch (error) {
        console.warn(
          'ProPrint cart error could not be read:',
          error
        );
      }

      throw new Error(errorMessage);
    }

    return response.json();
  }

  document.addEventListener(
    'click',
    async (event) => {
      const addButton = event.target.closest(
        'button[name="add"], button[type="submit"], input[type="submit"]'
      );

      if (!addButton) return;

      const productForm = addButton.closest('form');

      if (!productForm) return;

      const formAction =
        productForm.getAttribute('action') || '';

      if (!formAction.includes('/cart/add')) return;

      if (addButton.dataset.ppFeeBypass === 'true') {
        delete addButton.dataset.ppFeeBypass;
        return;
      }

      const api = getWizardAPI();

      if (typeof api.validate === 'function') {
        const validation = api.validate();

        if (!validation.valid) {
          event.preventDefault();
          event.stopImmediatePropagation();

          showWizardError(
            validation.message ||
            'Please complete your customisation options.'
          );

          return;
        }
      }

      const digitisingItems =
        typeof api.getDigitisingItems === 'function'
          ? api.getDigitisingItems()
          : [];

      if (!digitisingItems.length) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (
        addButton.dataset.ppCartProcessing === 'true'
      ) {
        return;
      }

      addButton.dataset.ppCartProcessing = 'true';
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');

      try {
        await addDigitisingFees(digitisingItems);

        addButton.dataset.ppFeeBypass = 'true';
        addButton.dataset.ppCartProcessing = 'false';
        addButton.disabled = false;
        addButton.removeAttribute('aria-busy');

        addButton.click();
      } catch (error) {
        addButton.dataset.ppCartProcessing = 'false';
        addButton.disabled = false;
        addButton.removeAttribute('aria-busy');

        console.error(
          'ProPrint digitisation fee error:',
          error
        );

        showWizardError(
          error.message ||
          'The embroidery setup fee could not be added. Please try again.'
        );
      }
    },
    true
  );
})();

/* EMBROIDERY-ONLY PRODUCTS */

(() => {
  const wizard = document.getElementById(
    'pp-branding-wizard'
  );

  if (
    !wizard ||
    wizard.dataset.embroideryOnly !== 'true' ||
    wizard.dataset.embroideryOnlyInitialised === 'true'
  ) {
    return;
  }

  wizard.dataset.embroideryOnlyInitialised = 'true';

  const positionConfig = {
    'Left Chest': 'left-chest-method',
    'Right Chest': 'right-chest-method',
    'Centre Front': 'centre-front-method',
    'Large Rear': 'large-rear-method'
  };

  const embroideryOnlyStyle =
    document.createElement('style');

  embroideryOnlyStyle.textContent = `
    #pp-branding-wizard[data-embroidery-only="true"]
    .pp-method-step {
      display: none !important;
    }
  `;

  document.head.appendChild(embroideryOnlyStyle);

  function getPositionInputs() {
    return Array.from(
      document.querySelectorAll(
        '.product-customizer-option' +
        '[data-option-name="branding-positions"] ' +
        'input[type="checkbox"]'
      )
    );
  }

  function getMethodRadios(group) {
    return Array.from(
      document.querySelectorAll(
        '.product-customizer-option' +
        '[data-option-name="' +
        group +
        '"] input[type="radio"]'
      )
    );
  }

  function findByValue(inputs, value) {
    return inputs.find(
      (input) =>
        input.value.trim() === value.trim()
    );
  }

  function selectEmbroidery(group) {
    let radios = getMethodRadios(group);

    let embroideryRadio = findByValue(
      radios,
      'Embroidery'
    );

    if (!embroideryRadio) return;

    const selectedRadio = radios.find(
      (radio) => radio.checked
    );

    if (
      selectedRadio &&
      selectedRadio.value.trim() === 'Embroidery'
    ) {
      return;
    }

    embroideryRadio.click();

    window.setTimeout(() => {
      radios = getMethodRadios(group);

      radios.forEach((radio) => {
        const selected =
          radio.value.trim() === 'Embroidery';

        radio.checked = selected;

        if (selected) {
          radio.setAttribute('checked', 'checked');
        } else {
          radio.removeAttribute('checked');
        }
      });

      embroideryRadio = findByValue(
        radios,
        'Embroidery'
      );

      if (embroideryRadio) {
        embroideryRadio.dispatchEvent(
          new Event('input', {
            bubbles: true
          })
        );

        embroideryRadio.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
    }, 100);
  }

  function hidePrintingChoices() {
    wizard
      .querySelectorAll(
        '[data-pp-method-value="Full-colour print"]'
      )
      .forEach((button) => {
        button.hidden = true;
      });

    const methodStep = wizard.querySelector(
      '[data-pp-method-step]'
    );

    if (methodStep) {
      methodStep.hidden = true;
    }
  }

  function updateStepNumbers() {
    const artworkNumber = wizard.querySelector(
      '[data-pp-artwork-step] .pp-step-number'
    );

    const digitisingNumber = wizard.querySelector(
      '[data-pp-digitising-step] .pp-step-number'
    );

    const reviewNumber = wizard.querySelector(
      '[data-pp-review-number]'
    );

    if (artworkNumber) {
      artworkNumber.textContent = '3';
    }

    if (digitisingNumber) {
      digitisingNumber.textContent = '4';
    }

    if (reviewNumber) {
      reviewNumber.textContent = '5';
    }
  }

  function syncEmbroideryOnlyOptions() {
    hidePrintingChoices();
    updateStepNumbers();

    const positionInputs = getPositionInputs();

    Object.entries(positionConfig).forEach(
      ([position, methodGroup]) => {
        const positionInput = findByValue(
          positionInputs,
          position
        );

        if (positionInput && positionInput.checked) {
          selectEmbroidery(methodGroup);
        }
      }
    );
  }

  function scheduleSync(delay = 320) {
    window.setTimeout(
      syncEmbroideryOnlyOptions,
      delay
    );
  }

  wizard.addEventListener('click', (event) => {
    if (
      event.target.closest('[data-pp-position]') ||
      event.target.closest('[data-pp-branding]')
    ) {
      scheduleSync();
    }
  });

  document.addEventListener('change', (event) => {
    const option = event.target.closest(
      '.product-customizer-option'
    );

    if (!option) return;

    const optionName =
      option.dataset.optionName || '';

    if (
      optionName === 'branding' ||
      optionName === 'branding-positions'
    ) {
      scheduleSync();
    }
  });

  let attempts = 0;

  const timer = window.setInterval(() => {
    attempts += 1;

    syncEmbroideryOnlyOptions();

    const methodsAvailable =
      Object.values(positionConfig).every(
        (group) =>
          getMethodRadios(group).length > 0
      );

    if (methodsAvailable || attempts >= 40) {
      window.clearInterval(timer);
      syncEmbroideryOnlyOptions();
    }
  }, 250);
})();

/* SAVED CUSTOMER LOGOS */

(() => {
  const wizard = document.getElementById('pp-branding-wizard');
  const dataElement = document.getElementById('pp-saved-logos-data');

  if (
    !wizard ||
    !dataElement ||
    wizard.dataset.savedLogosInitialised === 'true'
  ) {
    return;
  }

  let savedLogos = [];

  try {
    const parsedLogos = JSON.parse(dataElement.textContent || '[]');

    savedLogos = Array.isArray(parsedLogos)
      ? parsedLogos.filter((logo) => logo && logo.id)
      : [];
  } catch (error) {
    console.warn('ProPrint saved logos could not be read:', error);
    return;
  }

  if (!savedLogos.length) return;

  wizard.dataset.savedLogosInitialised = 'true';

  const panel = wizard.querySelector(
    '[data-pp-artwork-panel="ProPrint already has my logo"]'
  );

  const existingLogoField = wizard.querySelector(
    '[data-pp-existing-logo]'
  );

  if (!panel || !existingLogoField) return;

  const positionLabels = {
    'Left Chest': 'Left Chest',
    'Right Chest': 'Right Chest',
    'Centre Front': 'Centre Front',
    'Large Rear': 'Large Rear'
  };

  const positionCodes = {
    'Left Chest': 'LC',
    'Right Chest': 'RC',
    'Centre Front': 'CF',
    'Large Rear': 'LR'
  };

  const savedLogoSelector = document.createElement('div');
  savedLogoSelector.className = 'pp-saved-logo-selector';
  savedLogoSelector.dataset.ppSavedLogoSelector = '';

  const manualLabel = panel.querySelector(
    'label[for="pp-existing-logo-details"]'
  );

  const panelHeading = panel.querySelector('.pp-panel-heading');

  if (panelHeading) {
    panelHeading.innerHTML = `
      <strong>Choose your approved artwork</strong>
      <small>
        Select artwork from your ProPrint branding library. If the logo
        you need is not shown, use the reference box below.
      </small>
    `;
  }

  if (manualLabel) {
    manualLabel.textContent =
      'Can’t see the correct logo? Enter a business name or order number';

    panel.insertBefore(savedLogoSelector, manualLabel);
  } else {
    panel.insertBefore(savedLogoSelector, existingLogoField);
  }

  existingLogoField.placeholder =
    'For example: ProPrint or previous order #1234';

  const selectedLogos = {};
  let isSyncing = false;

  function getOptionInputs(optionName, type) {
    return Array.from(
      document.querySelectorAll(
        '.product-customizer-option[data-option-name="' +
        optionName +
        '"] input[type="' +
        type +
        '"]'
      )
    );
  }

  function getSelectedRadioValue(optionName) {
    const selected = getOptionInputs(optionName, 'radio')
      .find((radio) => radio.checked);

    return selected ? selected.value.trim() : '';
  }

  function getSelectedPositions() {
    return getOptionInputs(
      'branding-positions',
      'checkbox'
    )
      .filter((input) => input.checked)
      .map((input) => input.value.trim());
  }

  function getLogoReference(logo) {
    const idParts = String(logo.id).split('/');
    const shortId = idParts[idParts.length - 1];

    return {
      id: shortId,
      name: String(logo.name || 'Approved logo').trim()
    };
  }

  function getRequiredGroups() {
    const assignment = getSelectedRadioValue('logo-assignment');
    const positions = getSelectedPositions();

    if (assignment === 'Different logo for each position') {
      return positions.map((position) => ({
        key: position,
        label: positionLabels[position] || position
      }));
    }

    return positions.length
      ? [{ key: 'all', label: 'Logo for all selected positions' }]
      : [];
  }

  function buildReferenceValue(groups) {
    if (!groups.length) return '';

    const complete = groups.every(
      (group) => Boolean(selectedLogos[group.key])
    );

    if (!complete) return '';

    if (groups.length === 1 && groups[0].key === 'all') {
      const logo = getLogoReference(selectedLogos.all);

      return ('Saved logo: ' + logo.name + ' (#' + logo.id + ')')
        .slice(0, 100);
    }

    return groups
      .map((group) => {
        const logo = getLogoReference(selectedLogos[group.key]);
        const code = positionCodes[group.key] || group.key;

        return code + ': ' + logo.name + ' (#' + logo.id + ')';
      })
      .join('; ')
      .slice(0, 100);
  }

  function syncReference(groups) {
    const value = buildReferenceValue(groups);

    isSyncing = true;
    existingLogoField.value = value;

    existingLogoField.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    existingLogoField.dispatchEvent(
      new Event('change', { bubbles: true })
    );

    isSyncing = false;
  }

  function createLogoCard(logo, groupKey) {
    const button = document.createElement('button');
    const selected = selectedLogos[groupKey]?.id === logo.id;

    button.type = 'button';
    button.className =
      'pp-saved-logo-card' + (selected ? ' is-selected' : '');

    button.dataset.ppSavedLogoId = logo.id;
    button.dataset.ppSavedLogoGroup = groupKey;

    const visual = document.createElement('span');
    visual.className = 'pp-saved-logo-visual';

    if (logo.preview) {
      const image = document.createElement('img');
      image.src = logo.preview;
      image.alt = logo.name || 'Approved logo';
      image.loading = 'lazy';
      visual.appendChild(image);
    } else {
      const fallback = document.createElement('span');
      fallback.className = 'pp-saved-logo-fallback';
      fallback.textContent = 'LOGO';
      visual.appendChild(fallback);
    }

    const copy = document.createElement('span');
    copy.className = 'pp-saved-logo-copy';

    const name = document.createElement('strong');
    name.textContent = logo.name || 'Approved logo';

    const status = document.createElement('small');
    status.textContent = 'Approved artwork';

    copy.appendChild(name);
    copy.appendChild(status);

    const tick = document.createElement('span');
    tick.className = 'pp-saved-logo-tick';
    tick.textContent = '✓';

    button.appendChild(visual);
    button.appendChild(copy);
    button.appendChild(tick);

    return button;
  }

  function renderSavedLogos() {
    const groups = getRequiredGroups();

    savedLogoSelector.innerHTML = '';

    if (!groups.length) return;

    groups.forEach((group) => {
      const groupElement = document.createElement('div');
      groupElement.className = 'pp-saved-logo-group';

      const heading = document.createElement('div');
      heading.className = 'pp-saved-logo-heading';
      heading.textContent = group.label;

      const grid = document.createElement('div');
      grid.className = 'pp-saved-logo-grid';

      savedLogos.forEach((logo) => {
        grid.appendChild(createLogoCard(logo, group.key));
      });

      groupElement.appendChild(heading);
      groupElement.appendChild(grid);
      savedLogoSelector.appendChild(groupElement);
    });

    syncReference(groups);
  }

  savedLogoSelector.addEventListener('click', (event) => {
  const button = event.target.closest(
    '.pp-saved-logo-card'
  );

  if (!button) return;

  event.preventDefault();

  const logoId = String(
    button.dataset.ppSavedLogoId || ''
  );

  const groupKey =
    button.dataset.ppSavedLogoGroup || 'all';

  const logo = savedLogos.find(
    (item) => String(item.id) === logoId
  );

  if (!logo) {
    console.warn(
      'ProPrint could not match the selected saved logo:',
      logoId
    );

    return;
  }

  selectedLogos[groupKey] = logo;

  savedLogoSelector
    .querySelectorAll(
      '[data-pp-saved-logo-group="' +
      groupKey +
      '"]'
    )
    .forEach((card) => {
      card.classList.toggle(
        'is-selected',
        card === button
      );
    });

  syncReference(getRequiredGroups());
});

  existingLogoField.addEventListener('input', () => {
    if (isSyncing) return;

    Object.keys(selectedLogos).forEach((key) => {
      delete selectedLogos[key];
    });

    savedLogoSelector
      .querySelectorAll('.is-selected')
      .forEach((card) => card.classList.remove('is-selected'));
  });

  wizard.addEventListener('click', (event) => {
    if (
      event.target.closest('[data-pp-position]') ||
      event.target.closest('[data-pp-assignment]') ||
      event.target.closest(
        '[data-pp-artwork-source="ProPrint already has my logo"]'
      )
    ) {
      window.setTimeout(renderSavedLogos, 220);
    }
  });

  document.addEventListener('change', (event) => {
    const option = event.target.closest('.product-customizer-option');

    if (!option) return;

    const optionName = option.dataset.optionName || '';

    if (
      optionName === 'branding-positions' ||
      optionName === 'logo-assignment' ||
      optionName === 'artwork-source'
    ) {
      window.setTimeout(renderSavedLogos, 150);
    }
  });

  renderSavedLogos();
})();